__turbopack_context__.v({
  "list": "_6MFcHW_list",
  "option": "_6MFcHW_option",
  "popoverPaper": "_6MFcHW_popoverPaper",
  "suggestionsWrapper": "_6MFcHW_suggestionsWrapper",
});
